import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import utils from "../../utils/utils";
import DATE_FORMAT from "../../components/constants/dateFormat";
import apiCalls from "../../utils/apiCalls";
import {injectIntl} from "react-intl";

const AdminCouponRow = ({coupon, getCoupons, intl}) => {
  const endDate = coupon.endDate? utils.getDateFromString(coupon.endDate).format(DATE_FORMAT.display): '-';

  function deleteCoupon() {
    const confirmMessage = intl.formatMessage({id: 'coupon.view.delete.confirm'});

    if (window.confirm(confirmMessage)) {
      apiCalls.deleteCoupon(coupon.id)
        .then(() => {
          getCoupons();
        }).catch((errors) => {
        window.alert(utils.getErrorMessageFromResponse(errors, true));
      });
    }
  }

  return (
    <tr>
      <th scope="row">
        <Link to={`/admin/coupon/${coupon.id}`} className="link">
          {coupon.id}
        </Link>
      </th>
      <td>
        {coupon.code}
      </td>
      <td>
        {coupon.discountPercent}%
      </td>
      <td>
        {coupon.discountSum}{coupon.discountSum? '€': ''}
      </td>
      <td>
        {coupon.minOrderSize}
      </td>
      <td>
        {coupon.freeDeliveryEnabled? 'Yes': 'No'}
      </td>
      <td>
        {endDate}
      </td>
      <td>
        <Link to={`/admin/coupons/edit/${coupon.id}`} className="link">
          Edit
        </Link><br/>
        <button className="btn btn-normal-link" onClick={deleteCoupon}>Delete</button><br/>
      </td>
    </tr>
  );
}

AdminCouponRow.propTypes = {
  coupon: PropTypes.object.isRequired,
  getCoupons: PropTypes.func.isRequired,
};

AdminCouponRow.defaultProps = {};

export default injectIntl(AdminCouponRow);